import { Button, Heading, Modal, Text } from '@makemydeal/dr-ui-bricks-components';

import type { RemoveTradeInModalProps } from '../../types/TradeInOverviewTypes';
import { REMOVE_TRADE_IN_MODAL_CONTENT } from '../../constants';
import { RemoveTradeInModalActions, RemoveTradeInModalContent, RemoveTradeInModalLayer } from './TradeInOverview.style';

export const RemoveTradeInModal = ({ vehicleName, onCancel, onConfirm }: RemoveTradeInModalProps) => (
    <RemoveTradeInModalLayer data-testid="remove-trade-in-modal-layer">
        <Modal className="trade-in-modal-layer">
            <RemoveTradeInModalContent
                data-testid="remove-trade-in-modal"
                role="alertdialog"
                aria-labelledby="remove-trade-in-modal-title"
            >
                <Heading id="remove-trade-in-modal-title" as="h2" level={4} weight="bold">
                    {REMOVE_TRADE_IN_MODAL_CONTENT.title}
                </Heading>
                <Text size="base" data-testid="remove-trade-in-modal-body">
                    {`${vehicleName || REMOVE_TRADE_IN_MODAL_CONTENT.fallbackVehicleName} ${
                        REMOVE_TRADE_IN_MODAL_CONTENT.bodySuffix
                    }`}
                </Text>
                <RemoveTradeInModalActions>
                    <Button buttonStyle="secondary" onClick={onCancel} data-testid="remove-trade-in-modal-cancel">
                        {REMOVE_TRADE_IN_MODAL_CONTENT.cancelLabel}
                    </Button>
                    <Button buttonStyle="primary" onClick={onConfirm} data-testid="remove-trade-in-modal-confirm">
                        {REMOVE_TRADE_IN_MODAL_CONTENT.confirmLabel}
                    </Button>
                </RemoveTradeInModalActions>
            </RemoveTradeInModalContent>
        </Modal>
    </RemoveTradeInModalLayer>
);
